import type from "./type.js";
import { rem as breakpointRem } from "./breakpoints.js";

const displaySizes = type?.display?.sizes || {};

export default {
	displayHeadings: {
		fontFamily: type?.display?.fontFamily,
		d1: { ...displaySizes.d1 },
		d2: { ...displaySizes.d2 },
		d3: { ...displaySizes.d3 },
		d4: { ...displaySizes.d4 },
		d5: { ...displaySizes.d5 },
		d6: { ...displaySizes.d6 },
	},
	// size now references the canonical breakpoint scale (designTokens/breakpoints.js)
	// so Mantine layout sizes resolve identically to the MUI breakpoints.
	size: {
		...breakpointRem,
		topSectionHeight: "36rem",
	}
};
